// w30 Wedding is Coming — variant that renders the standalone HTML at
// /templates/wedding-is-coming.html (Game-of-Thrones-themed wedding —
// bone + gold + blood-red on stone-textured deep black, Cinzel + IM Fell
// English + Cormorant + UnifrakturCook display stack, ~440px shell with
// falling snow and a roman-numeral year) inside a full-bleed iframe.
//
// The customizer accepts groom/bride plus optional groomHouse/brideHouse
// to surname the two families ("House Karimov takes House Yusupova").
// Dates arrive as DD.MM.YYYY from the catalog and are converted to ISO
// here so the HTML stays byte-for-byte what the designer authored.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/wedding-is-coming.html";

function ddmmyyyyToIso(d?: string): string | undefined {
  if (!d) return undefined;
  const m = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(d);
  if (!m) return d;
  return `${m[3]}-${m[2]}-${m[1]}`;
}

export function WeddingIsComingStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) {
    const parts = t.names.split(/\s*&\s*/);
    if (parts[0]) params.set("groom", parts[0].trim());
    if (parts[1]) params.set("bride", parts[1].trim());
  }
  const iso = ddmmyyyyToIso(t.date);
  if (iso) params.set("date", iso);
  if (t.time) params.set("time", t.time);
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (ctx.slug) params.set("slug", ctx.slug);
  params.set("v", "2");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Wedding is Coming"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#0A0807",
      }}
    />
  );
}
